import React from "react";
import { Grid, Typography, Paper, Box } from "@mui/material";
import { ReactComponent as SmLogo } from "../Common/Logo/smLogo.svg";
import { ReactComponent as Mountains } from "../Common/Icons/mountains.svg";

const Maintenance = () => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        spacing={0}
        direction="column"
        justifyContent="center"
        alignItems="center"
        sx={{ minHeight: "100vh" }}
      >
        <Grid sx={{ display: "flex", justifyContent: "center" }}>
            <Box
              component={SmLogo}
              sx={{
                width: "100%",
                mb: 2,
                maxWidth: { xs: "80%", sm: "100%" },
                mt: { xs: "15px", sm: 0 },
                maxHeight: { sm: 160 },
              }}
            />
        </Grid>
        <Grid item>
          <Paper
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              minWidth: { xs: 100, sm: 600, md: 720 },
              maxWidth: { xs: '100%', sm: 600, md: 720 },
              minHeight: { xs: "100vh", sm: 'auto' },
            }}
          >
            <Grid
              container
              spacing={0}
              direction="row-reverse"
              justifyContent="center"
              alignItems="stretch"
              sx={{ minHeight: 200 }}
            >
              <Grid
                item
                size={{ xs: 12, sm: 5 }}
                sx={{
                  display: { xs: "none", sm: "flex" },
                  backgroundColor: "#FDEFE7",
                  borderTopRightRadius: 8,
                  borderBottomRightRadius: 8,
                  overflow: "hidden",
                }}
              >
                <Box
                  component={Mountains}
                  sx={{
                    width: "105%",
                    ml: -0.125,
                    alignSelf: "flex-end",
                    mb: -1.875,
                    height: { xs: "160%" },
                    width: { xs: "160%" },
                    mb: { xs: -2.5 },
                    alignSelf: { xs: "flex-start" },
                  }}
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 7 }}>
                <Box
                  sx={{
                    ml: { xs: 2, sm: 4 },
                    mr: { xs: 2, sm: 3.375 },
                    mt: { xs: 2, sm: 4 },
                    mb: { xs: 2, sm: 2.5 },
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{
                      pb: 1.25,
                      fontSize: { xs: 25, sm: 32 },
                    }}
                  >
                    Hang Tight! We're Making Things Better
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#5A6375",
                      fontSize: 14,
                      mt: 0.375,
                      mb: 2,
                    }}
                  >
                    We're taking a quick break for essential maintenance to enhance your experience.
                  </Typography>                       
                  <Typography variant="body1" sx={{
                      color: "#5A6375",
                      fontSize: 14,
                      mt: 0.375,
                      mb: 2,
                    }}>
                    We'll be back online soon with some exciting updates!
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Maintenance;
